export default "__VITE_ASSET__oS$Kb1gL__"